import Axios from "@/plugins/axios";

export default {
  async getMlBrowserData({ commit, state }, payload) {
    if (payload.isPageobject) {
      var ajaxParams = {
        id: payload.pageobject_id,
        CSRFToken: payload.CSRFToken,
      };
      var urlToCall = "/uiapi/po/getmlbrowserdata";
    } else {
      var ajaxParams = {
        testcaseid: payload.testcase_id,
        resource_id: payload.resource_id,
        CSRFToken: payload.CSRFToken,
      };
      var urlToCall = "/uiapi/detail/getmlbrowserdata";
    }
    if (payload && typeof payload.testresult_id != 'undefined' && payload.testresult_id) {
      ajaxParams["testresult_id"] = payload.testresult_id;
    }
    return new Promise((resolve, reject) => {
      Axios.post(urlToCall, ajaxParams).then((result) => {
        if (result.status === 200) {
          const data = state.mlData;
          data[payload.resource_id] = result.data.mldataarr;
          commit('setLastRunJobPath', result.data.last_run_job_path);
          commit('setMlData', { ...data });
          resolve(result.data);
        } else reject(result);
      })
      .finally(() => {});
    });
  },
  getAnomalyBrowserData({ commit, state }, payload) {
    let ajaxParams = {
      testcaseid: payload.testcase_id,
      sharecode: payload.sharecode,
      browser: payload.browser,
      testresult_id: payload.testresult_id,
      resource_id: payload.resource_id,
      CSRFToken: payload.CSRFToken,
    };
    Axios.post("/uiapi/detail/getanomalybrowserdatajson", ajaxParams).then((result) => {
      if (result.status === 200) {
        const data = state.actionsAnamolyStorage;
        data[payload.browser] = result.data;
        commit('setActionsAnamolyStorage', { ...data });
      }
    });
  },
};

